'use strict';

import Swal from 'sweetalert2';
import croppieModal from '../../modules/croppieModal';

const lightning = {
  settings: {
    $form: document.querySelector('.js-form-warcry'),
  },

  init() {
    croppieModal.init();

    if (s.$form) {
      s.$form.addEventListener('submit', e => {
        if (!e.target.video.value.trim().length && !e.target.lyric.value.trim().length) {
          e.preventDefault();
          Swal.fire('Erro!', 'Preencha ao menos um dos campos.', 'error');
        }
      });
    }
  },
};

const _this = lightning,
  s = _this.settings;

export default _this;
